/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmojiPreviewComponent.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N200, N900 } from '@atlaskit/theme/colors';
import CachingEmoji from './CachingEmoji';
var emojiName = null;
var emojiShortName = null;
var preview = null;
var previewImg = null;
var previewText = null;
export var EmojiPreviewComponent = function EmojiPreviewComponent(_ref) {
  var emoji = _ref.emoji;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _4cvr1h6o"])
  }, /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1o8l _1bsbzwfg _12s6idpf _1e4didpf _1dvqidpf _vwlxidpf _1gdiidpf _1f45idpf _pdfdidpf _mwo3idpf _5ilezwfg _boltzwfg _1pc7zwfg _u5wqzwfg _w7981kw7 _1vqe1kw7 _1l4xidpf _1l79idpf _118didpf _1pa4idpf _1pglh2mm _1vjf1ssb _1h6o1ssb _8fp6dbra _1os4zwfg _1e7azwfg _7mh21ule"])
  }, /*#__PURE__*/React.createElement(CachingEmoji, {
    key: emoji.id || emoji.shortName,
    emoji: emoji
  })), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _2lx21bp4 _1wpz1h6o _19pk1i6y _18u019bv _p12f3sup _1bsb3sup _16jlkb7n _1o9zkb7n"])
  }, emoji.name && /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo15vq _18m915vq _1e0c1ule _syazovqm _1bto1l2s _o5721q9c _299mangw"]),
    style: {
      "--_5xk3r4": ix("var(--ds-text, ".concat(N900, ")"))
    }
  }, emoji.name), /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c8dcr7 _1reo15vq _18m915vq _1e0c1ule _syazeqp7 _vwz4kb7n _otyr1i6y _n3tdv77o _1bto1l2s _o5721q9c _10hw2smr _pnmbovqm"]),
    style: {
      "--_158nz74": ix("var(--ds-text-subtle, ".concat(N200, ")")),
      "--_5xk3r4": ix("var(--ds-text, ".concat(N900, ")"))
    }
  }, emoji.shortName)));
};